import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { logger } from "@/lib/logger";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { refresh } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const fragment = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(fragment);
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/connexion", { replace: true });
        return;
      }
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await refresh();
        navigate("/mon-compte", { state: { user: r.data.user }, replace: true });
      } catch (e) {
        logger.error("Auth callback failed", e);
        navigate("/connexion", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <main className="max-w-md mx-auto px-6 py-24 text-center" data-testid="auth-callback">
      <div className="w-12 h-12 border-4 border-orange-200 border-t-orange-500 rounded-full animate-spin mx-auto mb-4" />
      <div className="font-bold">Connexion en cours...</div>
      <p className="text-sm text-[var(--ink-soft)] mt-1">Vous serez redirige automatiquement.</p>
    </main>
  );
}
